module.exports = __webpack_public_path__ + "static/media/09-1.1e63df9d.png";